import { Component, Input, OnInit, OnChanges, HostBinding, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { QueryCondition } from '../../entity/querycondition';
import { SolutionService } from '../../service/solution.service';
import { DateValue } from '../../entity/conditionvalue/datevalue';

@Component({
    selector: 'app-filter-date',
    templateUrl: './date.component.html'
})

export class DateComponent implements OnInit, OnChanges {

    /**
     * QueryCondition类型
     */
    @Input() item: any;
    @Input() autoLabel: boolean;
    @Input() disabled: boolean;
    @Input() showType: string;
    @Output() searchHandle = new EventEmitter();

    // time:Date;
    date: string;
    /** 判断是否是在扩展区域展示 */
    extend = false;
    /** 判断是否显示label */
    showlabel = true;
    placeholder: string;
    dateFormat: string;
    returnFormat: string;

    @HostBinding('class.filter-item-wrap')
    get isExtend(): boolean {
        return !this.extend && this.autoLabel;
    }
    @HostBinding('class.filter-item-hiddenlabel')
    get hidenLabel(): boolean {
        return !this.showlabel;
    }
    /**
   * 某个字段发生值变化事件时，需要同步清空的字段，可能不是当前字段
   */
    @Input() changeFields: Array<string> = [];
    constructor(private solutionService: SolutionService) { }

    ngOnInit(): void {
        // console.log(this.showType);
        this.initDate();
        if (this.item) {
            const type = Object.prototype.toString.call(this.item.placeHolder);
            if (type == '[object Undefined]') {
                if (this.item.control && this.item.control.hasOwnProperty('placeholder')) {
                    this.placeholder = this.item.control.placeholder;
                }
            }
            else {
                this.placeholder = this.item.placeHolder;
            }
        }
        if (this.item && this.item.control && this.item.control.hasOwnProperty('isExtend')) {
            this.extend = this.item.control.isExtend;
            if (!this.extend) {
                this.showlabel = this.item.control.showLabel;
            }
        }

        this.solutionService.addFilterEditorInstance(this.item.fieldCode, this);


        (this.item.value as DateValue).clear$.subscribe(() => {
            this.date = '';
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.initDate();
        if(changes['changeFields'] && changes['changeFields'].currentValue && !changes['changeFields'].firstChange) {
            const isChange = changes['changeFields'].currentValue.some(field => field == this.item.fieldCode);
            if(isChange) {
                this.date = this.item.value.getOriginalValue();             
            }
        }
    }

    initDate() {
        // if(this.item && this.item.value.value){
        //     //this.time = this.getDate((this.item.value as DateValue).value);
        //     this.time = (this.item.value as DateValue).value;
        // }

        if (this.item && this.item.value
            && (this.item.value as DateValue).value) {
            this.date = this.item.value.getOriginalValue();
        } else {
            this.date = undefined;
        }
        const format = this.showType == '2' ? 'yyyy-MM' : (this.showType == '3' ? 'yyyy' : 'yyyy-MM-dd');
        this.returnFormat = format;
        this.dateFormat = this.item.control.format ? this.item.control.format : format;
        // console.log('格式',this.dateFormat);

    }

    // getDate(dateString:string):Date{
    //     let arr1:Array<any> = dateString.split(" "); 
    //     let sdate = arr1[0].split('-'); 
    //     let date = new Date(sdate[0], sdate[1]-1, sdate[2]); 
    //     return date;
    // }

    onDateChange(event: any) {
        // console.log(event);
        if (event) {
            (this.item.value as DateValue).value = event.returnFormatted;
        } else {
            (this.item.value as DateValue).value = '';
            // this.item.value = new DateValue();
        }
        if (this.disabled) { return; }
        this.searchHandle.emit(event);
    }

    // getConditionItemStyle(field: QueryCondition, controlType: any) {
    //     return this.solutionService.getConditionItemStyle(field,controlType);
    // }

    getConditionItemTitle(field: QueryCondition) {
        return this.solutionService.getConditionItemTitle(field);
    }
}
